"use strict";

var _extends = Object.assign || function (r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];

    for (var o in t) {
      Object.prototype.hasOwnProperty.call(t, o) && (r[o] = t[o]);
    }
  }

  return r;
},
    React = require("react"),
    PropTypes = require("prop-types"),
    AlertBanner = require("./AlertBanner.js"),
    ErrorIcon = require("../icons/ErrorIcon.js"),
    ErrorAlert = function ErrorAlert(r) {
  return React.createElement(AlertBanner, _extends({}, r, {
    className: "blx-error " + r.className,
    icon: React.createElement(ErrorIcon, {
      className: "blx-alert-icon"
    })
  }));
};

ErrorAlert.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  closable: PropTypes.bool
}, ErrorAlert.defaultProps = {
  className: "",
  title: "Error",
  closable: !1
}, module.exports = ErrorAlert;